/// <reference path="../_all.ts" />

module blog {
  'use strict';

  function pad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length-size);
  }

  export class ScrubberCtrl {

    public static $inject = [
      '$scope',
      '$timeout',
      'pageMetaService',
    ];

    constructor(
      private $scope: IScrubberCtrlScope,
      private $timeout: ng.ITimeoutService,
      private pageMetaService: navigation.IPageMetaService
    ) {

      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      //var data = "FFFFFFFF";
      //var data = "013B0902";
      //var data = "00000000";
       

      $scope.data = "00000000";

      this.$timeout(() => { $scope.dataForm.$setDirty(); })


      $scope.$watch('data', (newVal : string, oldVal : string) => {
        if (newVal != oldVal) {   
          newVal = newVal + '00000000'; 
          this.lowByte = parseInt(newVal.substr(4,4), 16);
          this.highByte = parseInt(newVal.substr(0,4), 16);    
          if (isNaN(this.lowByte)) this.lowByte = 0;
          if (isNaN(this.highByte)) this.highByte = 0;
          $scope.binary = pad(this.highByte.toString(2),16) + pad(this.lowByte.toString(2), 16);
        }
      });

    }

    lowByte : number = 0;
    highByte : number = 0;


    getBit(index: number) : boolean {
      var b = this.lowByte;
      if (index > 15) {
        b = this.highByte;
        index = index - 16;
      }
      return (b & (1 << index)) > 0;
    }

    getBitRange(start: number, stop: number) : number {
      var b = this.lowByte;
      if (start > 15) {
        b = this.highByte;
        start = start - 16;
        stop = stop - 16;
      }

      var mask = 0;
      for (var i = start; i <= stop; i++) {
        mask = mask | (1 << i);
      }

      var ret = (b & mask) >> start;
      return ret;
    }

    public init(data :  any) {
      this.$scope.initData = data;
    }
   

  }
}